// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2isPs","content":"styles_content__S_NUl","checkbox":"styles_checkbox__FpRji","checkboxLabel":"styles_checkboxLabel__2X_lP"};